import Common from '@/utils/common'

export function getData(data) {
  return Common.createRequest('crossborder-order-api', 'query_reconcilia_file', data)
}

export function getDownloadData(data) {
  return Common.createDownRequest('crossborder-merchant-api', 'crossborder_file_download', data)
}